import { version } from './Version'

export class Settings {
	static baseUrl = import.meta.env.VITE_ASSET_URL
	// static cacheId = "2f2788c9-5700-4a25-83b5-0b2d2f68881f"
	static timestamp: string

	static morphDuration = 1
	static cameraDuration = 1.5

	static promise: Promise<void>

	static version = '1'
	// static defaultEnvironment = "MAIN V3.env"
	static LOD: number
	static AO: boolean = true

	static rawAssets: boolean = false

	static cloneParts: boolean = true
	static telemetry: boolean = true

	static telemetryConnectionString = 'InstrumentationKey=99ef1240-87ab-46f8-ab74-cf5a14a7a8b2;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f6a5201e-67b2-452b-8962-cdfba2a1d270'
	static testTelemetryConnectionString = 'InstrumentationKey=2460cf78-2933-485b-b4f5-c565047757da;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=8fee3ccc-9131-4749-a84c-28613fcaac63'

	// static lod = 2
}

export function GetUrl(path: string) {
	const input = path
	if (path.startsWith('https://')) path = new URL(path).pathname
	if (path.startsWith('/')) path = path.substring(1)
	if (path.startsWith('LOD/')) path = path.substring('LOD/0/'.length)

	if (path.startsWith('Original/')) path = path.substring('Original/'.length)

	if ((path.startsWith('AO') || path.startsWith('Textures') || path.startsWith('Environments')) && Settings.LOD > 0) {
		path = `LOD/${Settings.LOD}/${path}`
	} else if (path.startsWith('AO') || path.startsWith('Textures')) {
		// console.log(path)
		path = path.replaceAll('.webp', '')
		path = path.replaceAll('.png', '')
		path = Settings.rawAssets ? `Original/${path}.png` : `${path}.webp`
		// console.log(path)
	}

	if (Settings.rawAssets && ['Bridges', 'Bushings', 'Clips', 'Fronts', 'Lenses', 'Nosepads', 'Temples'].some(x => path.startsWith(x + '/'))) {
		path = `Original/${path}`
	}
	if (!Settings.timestamp && !Settings.promise) {
		Settings.promise = GetTimestamp()
	}
	if (!Settings.timestamp) Settings.timestamp = localStorage.getItem('timestamp') ?? 'latest'
	const url = `${Settings.baseUrl}/${path}?v=${version}.${Settings.timestamp}&origin=${window.location.origin}`
	return url
}

export async function GetTimestamp() {
	const response = await fetch(`${Settings.baseUrl}/timestamp.txt?r=${Math.random()}`)
	if (!response.ok) return
	const newValue = await response.text()
	if (localStorage.getItem('timestamp') && localStorage.getItem('timestamp') != newValue) {
		console.warn('NEW VERSION AVAILABLE', new Date(Number.parseInt(newValue, 36)).toLocaleString())
	}

	Settings.timestamp = newValue

	localStorage.setItem('timestamp', Settings.timestamp)
}
